import { MenuItem } from '@/types/menu-item';
import { MenuItemWire } from '../schemas/menu-item';

/**
 * Mapping functions to convert wire format (backend) to domain format (app)
 */

/**
 * Convert wire menu item format to domain menu item format
 * Handles type conversions: ISO strings -> Unix timestamps, null -> undefined
 */
export function mapMenuItemWireToDomain(wire: MenuItemWire): MenuItem {
  // Convert ISO datetime strings to Unix timestamps (milliseconds)
  const createdAt = wire.created_at ? new Date(wire.created_at).getTime() : Date.now();
  const updatedAt = wire.updated_at ? new Date(wire.updated_at).getTime() : Date.now();

  return {
    id: wire.id,
    businessId: wire.business_id,
    name: wire.name,
    description: wire.description || undefined, // Convert null to undefined
    coverPhotoR2Key: wire.cover_photo_r2_key || undefined, // Convert null to undefined
    status: wire.status,
    createdBy: wire.created_by,
    updatedBy: wire.updated_by,
    createdAt,
    updatedAt,
    businessName: wire.business_name || undefined,
    checkInCount: wire.check_in_count ?? undefined,
    ratingDistribution: wire.rating_distribution
      ? {
          notForMe: wire.rating_distribution.not_for_me,
          okay: wire.rating_distribution.okay,
          tryIt: wire.rating_distribution.try_it,
          mustTry: wire.rating_distribution.must_try,
        }
      : null,
  };
}

/**
 * Convert domain menu item format to wire format (for requests)
 */
export function mapMenuItemDomainToWire(domain: Partial<MenuItem>): Partial<MenuItemWire> {
  const wire: Partial<MenuItemWire> = {};

  if (domain.id !== undefined) wire.id = domain.id;
  if (domain.businessId !== undefined) wire.business_id = domain.businessId;
  if (domain.name !== undefined) wire.name = domain.name;
  if (domain.description !== undefined) wire.description = domain.description;
  if (domain.coverPhotoR2Key !== undefined) wire.cover_photo_r2_key = domain.coverPhotoR2Key;
  if (domain.status !== undefined) wire.status = domain.status;
  if (domain.createdBy !== undefined) wire.created_by = domain.createdBy;
  if (domain.updatedBy !== undefined) wire.updated_by = domain.updatedBy;
  if (domain.createdAt !== undefined) wire.created_at = new Date(domain.createdAt).toISOString();
  if (domain.updatedAt !== undefined) wire.updated_at = new Date(domain.updatedAt).toISOString();
  if (domain.businessName !== undefined) wire.business_name = domain.businessName;

  return wire;
}
